<template>
  <!-- 账户管理---企业信息 -->
  <div class="page">
    <!-- 页面详情 -->
    <div v-for="(item, index) in titleList" :key="index">
      <blue-title>{{ item.title }}</blue-title>
      <ContentList :title="item.title"></ContentList>
    </div>
    <div class="footer">
      <el-button type="primary">返回</el-button>
      <el-button class="edit-btn" @click="editClick">修改</el-button>
    </div>
  </div>
</template>

<script>
import ContentList from '@account/components/enterprise/contentIndex';
export default {
  components: {
    ContentList,
  },
  data() {
    return {
      titleList: [
        {
          title: '公司基本信息',
        },
        {
          title: '营业执照',
        },
        {
          title: '企业法人／经办人',
        },
      ],
    };
  },
  methods: {
    // 编辑
    editClick() {
      this.$router.push({ name: 'account/enterprise/edit' });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  height: 100%;
  background: @bg-white;
  padding-top: 20px;
}
.footer {
  text-align: center;
  margin-top: 30px;
  .el-button {
    padding: 12px 35px;
    margin-right: 20px;
    font-size: 14px;
    font-weight: 400;
  }
  .edit-btn {
    color: #4359b7;
    border-color: #4359b7;
  }
}
</style>
